import request from '../util/request'

export function getFiles(params) {
  return request({
    url: 'pr/files',
    method: 'get',
    params
  })
}

export function signature(params) {
  return request({
    url: 'pr/files/alioss/signature',
    method: 'get',
    params
  })
}